import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["text"];
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button/standard-button';
import ModalDialog, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { Text } from '@atlaskit/primitives/compiled';
import { PfLink } from '../PfLink';
import { ErrorSection } from './ErrorSection';
import { IntlNoticeMessages, NoticeMessage } from './NoticeMessages.intl';
export var NoticeDialog = function NoticeDialog(_ref) {
  var title = _ref.title,
    titleVars = _ref.titleVars,
    message = _ref.message,
    messageVars = _ref.messageVars,
    confirmText = _ref.confirmText,
    confirmLink = _ref.confirmLink,
    handleClose = _ref.handleClose,
    isErrorNotice = _ref.isErrorNotice,
    errorDetails = _ref.errorDetails,
    isWarningNotice = _ref.isWarningNotice,
    overrideZIndex = _ref.overrideZIndex;
  var appearance = isErrorNotice ? 'danger' : isWarningNotice ? 'warning' : undefined;
  var actions = [];
  if (isErrorNotice) {
    // No unconfirmed close button.
  } else if (confirmLink) {
    actions.push({
      text: /*#__PURE__*/React.createElement(FormattedMessage, IntlNoticeMessages[NoticeMessage.Close]),
      onClick: function onClick() {
        return handleClose(false);
      },
      appearance: 'subtle'
    });
  } else {
    actions.push({
      text: /*#__PURE__*/React.createElement(FormattedMessage, IntlNoticeMessages[NoticeMessage.Cancel]),
      onClick: function onClick() {
        return handleClose(false);
      },
      appearance: 'subtle'
    });
  }
  var primaryButtonAppearance = appearance || 'primary';
  if (confirmLink) {
    actions.push({
      // @ts-ignore
      text: /*#__PURE__*/React.createElement(FormattedMessage, confirmText),
      href: confirmLink,
      target: '_blank',
      rel: 'noopener noreferrer',
      appearance: primaryButtonAppearance
    });
  } else {
    actions.push({
      // @ts-ignore
      text: /*#__PURE__*/React.createElement(FormattedMessage, confirmText),
      onClick: function onClick() {
        return handleClose(true);
      },
      appearance: primaryButtonAppearance
    });
  }
  var onOpenCompleteF;
  if (overrideZIndex) {
    onOpenCompleteF = function onOpenCompleteF(node, isAppearing) {
      overrideZIndex && node.parentElement ? node.parentElement.style.zIndex = '5000' : undefined;
    };
  }
  return /*#__PURE__*/React.createElement(ModalDialog, {
    onOpenComplete: onOpenCompleteF,
    onClose: function onClose() {
      return handleClose();
    },
    shouldCloseOnOverlayClick: false
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, {
    appearance: appearance
  },
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(FormattedMessage, _extends({}, title, {
    values: titleVars
  })))), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("div", null,
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(FormattedMessage, _extends({}, message, {
    values: messageVars
  }))), isErrorNotice && /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, /*#__PURE__*/React.createElement(FormattedMessage, IntlNoticeMessages[NoticeMessage.ErrorExplanations1]), ' ', /*#__PURE__*/React.createElement(PfLink, {
    href: "http://links.thinktilt.net/error-explanations"
  }, /*#__PURE__*/React.createElement(FormattedMessage, IntlNoticeMessages[NoticeMessage.ErrorExplanations2])), ' ', /*#__PURE__*/React.createElement(FormattedMessage, IntlNoticeMessages[NoticeMessage.ErrorExplanations3]), ' ', /*#__PURE__*/React.createElement(PfLink, {
    href: "https://support.thinktilt.com/"
  }, /*#__PURE__*/React.createElement(FormattedMessage, IntlNoticeMessages[NoticeMessage.ErrorExplanations4])), "."), !!errorDetails && /*#__PURE__*/React.createElement(ErrorSection, {
    errorDetails: errorDetails
  })), /*#__PURE__*/React.createElement(ModalFooter, null, actions.map(function (_ref2) {
    var text = _ref2.text,
      props = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement(Button, props, text);
  })));
};